"use client";

import type { ReactNode, TextareaHTMLAttributes } from "react";

export interface GlassTextEditorProps
	extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	readonly label: string;
	readonly counter?: ReactNode;
}

/**
 * GlassTextEditor — multi-line text editor with a label and optional counter.
 * Mirrors `DSGlassTextEditor` on iOS.
 */
export function GlassTextEditor({
	label,
	counter,
	className = "",
	...props
}: Readonly<GlassTextEditorProps>) {
	return (
		<label className={`ds-field ds-field--editor ${className}`.trim()}>
			<span className="ds-field__heading">
				<span className="ds-field__label">{label}</span>
				{counter === undefined ? null : <span>{counter}</span>}
			</span>
			<span className="ds-field__control">
				<textarea aria-label={label} {...props} />
			</span>
		</label>
	);
}
